// SubjectContext.tsx
import React, { createContext, useState, useContext } from "react";

type SubjectContextType = {
  subject: string;
  setSubject: (value: string) => void;
};

const SubjectContext = createContext<SubjectContextType | undefined>(undefined);

export const SubjectProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [subject, setSubject] = useState("");
  return (
    <SubjectContext.Provider value={{ subject, setSubject }}>
      {children}
    </SubjectContext.Provider>
  );
};

export const useSubject = () => {
  const context = useContext(SubjectContext);
  if (!context) throw new Error("useSubject must be used within a SubjectProvider");
  return context;
};
